import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const PRODUCTS = [
  { to: '/product/total-protection', icon: '◉', bg: '#eff6ff', label: 'Total Protection Suite', desc: 'All-in-one shield across every paid and organic channel.' },
  { to: '/product/ppc-shield',       icon: '⛉', bg: '#f0fdf4', label: 'PPC Shield',             desc: 'Real-time click-fraud blocking for Google, Meta & Microsoft.' },
  { to: '/product/bot-mitigation',   icon: '◍', bg: '#fef3c7', label: 'Bot Mitigation',         desc: 'Stop scrapers, crawlers and automation beyond the click.' },
  { to: '/product/lead-shield',      icon: '⤶', bg: '#fdf2f8', label: 'Lead Shield',            desc: 'Score every form submission and block fake leads from your CRM.' },
];

const PR_RESOURCES = [
  { to: '/about',            icon: 'ℹ', bg: '#f0f9ff', label: 'About Us',         desc: 'Our mission and how ClickSaver works.' },
  { to: '/blog',             icon: '▤', bg: '#eff6ff', label: 'Blog',             desc: 'Articles and guides on click fraud and PPC.' },
  { to: '/case-studies',     icon: '◱', bg: '#f0fdf4', label: 'Case Studies',     desc: 'Real results from real ClickSaver customers.' },
  { to: '/faq',              icon: '◉', bg: '#f5f3ff', label: 'FAQ',              desc: 'Answers to the most common questions.' },
  { to: '/knowledge-center', icon: '◈', bg: '#fff7ed', label: 'Knowledge Center', desc: 'Setup guides, docs, and tutorials.' },
  { to: '/press',            icon: '▦', bg: '#fef2f2', label: 'Press',            desc: 'ClickSaver in the news and media.' },
  { to: '/research',         icon: '◎', bg: '#ecfeff', label: 'Research',         desc: 'Data and insights on ad fraud trends.' },
  { to: '/reviews',          icon: '★', bg: '#fffbeb', label: 'Reviews',          desc: 'What customers say about ClickSaver.' },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .pr-root { font-family: 'Inter', sans-serif; background: #fff; color: #0f172a; -webkit-font-smoothing: antialiased; overflow-x: hidden; }

  @keyframes shimmer { 0% { background-position:-200% center; } 100% { background-position:200% center; } }
  @keyframes slideIn { from { opacity:0; transform:translateX(100%); } to { opacity:1; transform:translateX(0); } }

  .pr-gradient { background: linear-gradient(135deg,#2563eb,#7c3aed); background-size:200%; -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; animation:shimmer 5s linear infinite; }

  .pr-nav { position:sticky; top:0; z-index:100; background:rgba(255,255,255,0.97); backdrop-filter:blur(16px); border-bottom:1px solid #f1f5f9; box-shadow:0 1px 12px rgba(0,0,0,0.06); }
  .pr-nav-inner { max-width:1200px; margin:0 auto; display:flex; align-items:center; height:64px; padding:0 24px; gap:8px; }
  .pr-nav-a { color:#475569; text-decoration:none; font-size:14px; font-weight:500; padding:6px 12px; border-radius:8px; transition:all .2s; }
  .pr-nav-a:hover { color:#0f172a; background:#f1f5f9; }

  .pr-dropdown { position:relative; }
  .pr-dropdown-btn { display:flex; align-items:center; gap:4px; color:#475569; font-size:14px; font-weight:500; padding:6px 12px; border-radius:8px; cursor:pointer; background:none; border:none; font-family:Inter,sans-serif; transition:all .2s; }
  .pr-dropdown-btn:hover, .pr-dropdown-btn.open { color:#0f172a; background:#f1f5f9; }
  .pr-dropdown-arrow { font-size:10px; transition:transform .2s; }
  .pr-dropdown-arrow.open { transform:rotate(180deg); }
  .pr-dropdown-menu { position:absolute; top:100%; left:50%; transform:translateX(-50%); margin-top:12px; background:#fff; border:1px solid #e2e8f0; border-radius:16px; padding:8px; box-shadow:0 16px 48px rgba(0,0,0,0.12); width:560px; display:grid; grid-template-columns:1fr 1fr; gap:2px; z-index:300; }
  .pr-dropdown-menu::before { content:''; position:absolute; left:0; right:0; top:-14px; height:14px; }
  .pr-dropdown-menu::before { content:''; position:absolute; left:0; right:0; top:-14px; height:14px; }
  .pr-dropdown-item { display:flex; align-items:flex-start; gap:12px; padding:12px 14px; border-radius:10px; text-decoration:none; transition:background .15s; }
  .pr-dropdown-item:hover { background:#f8fafc; }
  .pr-dropdown-icon { width:36px; height:36px; border-radius:9px; display:flex; align-items:center; justify-content:center; font-size:17px; flex-shrink:0; }
  .pr-dropdown-label { font-size:14px; font-weight:600; color:#0f172a; margin-bottom:2px; }
  .pr-dropdown-desc { font-size:12px; color:#64748b; line-height:1.5; }

  .pr-toggle { display:inline-flex; background:#f1f5f9; border-radius:40px; padding:4px; border:1px solid #e2e8f0; }
  .pr-toggle-btn { padding:8px 22px; border-radius:36px; font-size:14px; font-weight:600; cursor:pointer; border:none; transition:all .2s; font-family:Inter,sans-serif; }
  .pr-toggle-on  { background:#2563eb; color:#fff; box-shadow:0 2px 10px rgba(37,99,235,.3); }
  .pr-toggle-off { background:transparent; color:#64748b; }

  .pr-card { transition:transform .25s, box-shadow .25s; }
  .pr-card:hover { transform:translateY(-4px); box-shadow:0 16px 48px rgba(0,0,0,.1); }

  .pr-check { color:#22c55e; font-weight:700; margin-right:8px; flex-shrink:0; }
  .pr-dash  { color:#cbd5e1; margin-right:8px; flex-shrink:0; }

  .pr-faq-btn { width:100%; text-align:left; padding:18px 20px; background:none; border:none; cursor:pointer; display:flex; justify-content:space-between; align-items:center; color:#0f172a; font-size:15px; font-weight:600; font-family:Inter,sans-serif; transition:background .2s; border-radius:12px; }
  .pr-faq-btn:hover { background:#f8fafc; }

  .pr-hamburger { display:none; flex-direction:column; gap:5px; cursor:pointer; background:none; border:none; padding:8px; border-radius:8px; }
  .pr-hamburger span { width:22px; height:2px; background:#475569; border-radius:2px; display:block; }
  .pr-mobile-menu { display:none; position:fixed; inset:0; z-index:999; background:#fff; padding:80px 24px 32px; flex-direction:column; gap:8px; animation:slideIn .25s ease; }
  .pr-mobile-menu.open { display:flex; }
  .pr-mobile-a { color:#0f172a; text-decoration:none; font-size:18px; font-weight:600; padding:14px 0; border-bottom:1px solid #f1f5f9; display:block; }

  @media (max-width:900px) {
    .pr-plans { grid-template-columns:1fr !important; max-width:440px !important; margin:0 auto !important; }
    .pr-compare { display:none !important; }
    .pr-nav-links { display:none !important; }
    .pr-nav-signin { display:none !important; }
    .pr-hamburger { display:flex !important; }
    .pr-hero-h1 { font-size:36px !important; letter-spacing:-1px !important; }
    .pr-section { padding:60px 20px !important; }
    .pr-faq-max { max-width:100% !important; }
  }
  @media (max-width:480px) { .pr-hero-h1 { font-size:30px !important; } }
`;

const LOGO = ({ dark = false }) => (
  <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 9 }}>
    <div style={{ width: 34, height: 34, borderRadius: 10, background: 'linear-gradient(135deg,#2563eb,#7c3aed)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, color: '#fff', fontWeight: 800 }}>⊛</div>
    <span style={{ fontFamily: 'Inter,sans-serif', fontWeight: 800, fontSize: 17, color: dark ? '#fff' : '#0f172a', letterSpacing: '-0.4px' }}>ClickSaver</span>
  </Link>
);

const FooterLink = ({ to, children }) => (
  <Link to={to} style={{ display: 'block', marginBottom: 10, color: '#64748b', textDecoration: 'none', fontSize: 14, transition: 'color .2s' }}
    onMouseEnter={e => e.target.style.color = '#fff'} onMouseLeave={e => e.target.style.color = '#64748b'}>{children}</Link>
);

const PLANS = [
  {
    id: 'starter', name: 'Starter', monthlyPrice: 69, yearlyPrice: 55,
    desc: 'Perfect for small businesses and solo advertisers.',
    color: '#475569',
    features: ['10,000 clicks/month','1 campaign','Real-time fraud detection','Automatic IP blocking','Google Ads IP exclusions','Basic fraud analytics','Weekly & monthly reports','Email support'],
  },
  {
    id: 'pro', name: 'Pro', monthlyPrice: 109, yearlyPrice: 87,
    desc: 'For growing businesses that need deeper protection.',
    color: '#2563eb', badge: 'Most Popular', highlighted: true,
    features: ['50,000 clicks/month','3 campaigns','Real-time fraud detection','Automatic IP blocking','Google Ads IP exclusions','Advanced fraud analytics','Weekly & monthly reports','Priority email support','Competitor click detection','VPN & proxy detection'],
  },
  {
    id: 'advanced', name: 'Advanced', monthlyPrice: 139, yearlyPrice: 111,
    desc: 'For agencies and high-spend advertisers.',
    color: '#059669',
    features: ['Unlimited clicks/month','Unlimited campaigns','Real-time fraud detection','Automatic IP blocking','Google Ads IP exclusions','Advanced fraud analytics','Weekly & monthly reports','Priority email & chat','Competitor click detection','VPN & proxy detection','Custom detection rules','White-glove onboarding'],
  },
];

const COMPARE = [
  { label: 'Clicks per month',          starter:'10,000',    pro:'50,000',        advanced:'Unlimited' },
  { label: 'Campaigns',                 starter:'1',         pro:'3',             advanced:'Unlimited' },
  { label: 'Real-time detection',        starter:true,        pro:true,            advanced:true },
  { label: 'Automatic IP blocking',      starter:true,        pro:true,            advanced:true },
  { label: 'Google Ads IP exclusions',   starter:true,        pro:true,            advanced:true },
  { label: 'Fraud analytics',            starter:'Basic',     pro:'Advanced',      advanced:'Advanced' },
  { label: 'Email reports',              starter:true,        pro:true,            advanced:true },
  { label: 'Fraud spike alerts',         starter:true,        pro:true,            advanced:true },
  { label: 'Slack / webhook alerts',     starter:false,       pro:true,            advanced:true },
  { label: 'Competitor click detection', starter:false,       pro:true,            advanced:true },
  { label: 'VPN & proxy detection',      starter:false,       pro:true,            advanced:true },
  { label: 'Custom detection rules',     starter:false,       pro:false,           advanced:true },
  { label: 'White-glove onboarding',     starter:false,       pro:false,           advanced:true },
  { label: 'Support',                    starter:'Email',     pro:'Priority email',advanced:'Priority email & chat' },
];

const FAQS = [
  { q: 'Is there a free trial?', a: 'Yes — every plan comes with a 7-day free trial. No credit card required to get started.' },
  { q: 'Can I change plans later?', a: 'Absolutely. You can upgrade or downgrade at any time from your account settings. Changes apply immediately.' },
  { q: 'What happens if I exceed my click limit?', a: "We'll notify you when you're getting close. You can upgrade anytime. Protection pauses for excess clicks until you upgrade." },
  { q: 'Do you offer refunds?', a: "If you're not satisfied within your first 14 days on a paid plan, we'll refund you in full — no questions asked." },
  { q: 'How does Google Ads IP exclusion work?', a: 'ClickSaver connects to your Google Ads account and pushes fraudulent IPs to your campaign exclusion lists automatically in real-time.' },
  { q: 'Is my data safe?', a: 'All data is encrypted at rest and in transit. We are fully GDPR compliant and never sell or share your data.' },
];

function Cell({ v }) {
  if (v === true)  return <span style={{ color: '#22c55e', fontWeight: 700 }}>✓</span>;
  if (v === false) return <span style={{ color: '#cbd5e1' }}>—</span>;
  return <span style={{ fontSize: 13, color: '#475569' }}>{v}</span>;
}

export default function Pricing() {
  const [openFaq, setOpenFaq] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [productOpen, setProductOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const productRef = useRef(null);
  const resourcesRef = useRef(null);

  useEffect(() => {
    const fn = (e) => {
      if (productRef.current && !productRef.current.contains(e.target)) setProductOpen(false);
      if (resourcesRef.current && !resourcesRef.current.contains(e.target)) setResourcesOpen(false);
    };
    document.addEventListener('mousedown', fn);
    return () => document.removeEventListener('mousedown', fn);
  }, []);

  return (
    <div className="pr-root">
      <style>{CSS}</style>

      {/* Mobile menu */}
      <div className={`pr-mobile-menu ${menuOpen ? 'open' : ''}`}>
        <button onClick={() => setMenuOpen(false)} style={{ position: 'absolute', top: 18, right: 18, background: '#f1f5f9', border: 'none', borderRadius: 8, width: 36, height: 36, fontSize: 20, cursor: 'pointer', color: '#475569', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
        <Link to="/" className="pr-mobile-a" onClick={() => setMenuOpen(false)}>Home</Link>
        <Link to="/#features" className="pr-mobile-a" onClick={() => setMenuOpen(false)}>Product</Link>
        <Link to="/pricing" className="pr-mobile-a" onClick={() => setMenuOpen(false)}>Pricing</Link>
        <Link to="/agencies" className="pr-mobile-a" onClick={() => setMenuOpen(false)}>Agencies</Link>
        <Link to="/knowledge-center" className="pr-mobile-a" onClick={() => setMenuOpen(false)}>Resources</Link>
        <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <Link to="/login" onClick={() => setMenuOpen(false)} style={{ display: 'block', textAlign: 'center', padding: '13px', borderRadius: 10, fontSize: 15, fontWeight: 600, textDecoration: 'none', border: '1.5px solid #e2e8f0', color: '#374151' }}>Sign In</Link>
          <Link to="/register" onClick={() => setMenuOpen(false)} style={{ display: 'block', textAlign: 'center', padding: '13px', borderRadius: 10, fontSize: 15, fontWeight: 600, textDecoration: 'none', background: '#2563eb', color: '#fff' }}>Start Free Trial</Link>
        </div>
      </div>

      {/* Navbar */}
      <nav className="pr-nav">
        <div className="pr-nav-inner">
          <LOGO />
          <div className="pr-nav-links" style={{ display: 'flex', gap: 4, marginLeft: 32 }}>
            <div
              className="pr-dropdown"
              ref={productRef}
              onMouseEnter={() => setProductOpen(true)}
              onMouseLeave={() => setProductOpen(false)}
            >
              <button className={`pr-dropdown-btn ${productOpen ? 'open' : ''}`} onClick={() => setProductOpen(o => !o)}>
                Product <span className={`pr-dropdown-arrow ${productOpen ? 'open' : ''}`}>▾</span>
              </button>
              {productOpen && (
                <div className="pr-dropdown-menu">
                  {PRODUCTS.map(p => (
                    <Link key={p.label} to={p.to} className="pr-dropdown-item" onClick={() => setProductOpen(false)}>
                      <div className="pr-dropdown-icon" style={{ background: p.bg }}>{p.icon}</div>
                      <div>
                        <div className="pr-dropdown-label">{p.label}</div>
                        <div className="pr-dropdown-desc">{p.desc}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <Link to="/pricing" className="pr-nav-a" style={{ color: '#2563eb', fontWeight: 600 }}>Pricing</Link>
            <Link to="/agencies" className="pr-nav-a">Agencies</Link>
            <div
              className="pr-dropdown"
              ref={resourcesRef}
              onMouseEnter={() => setResourcesOpen(true)}
              onMouseLeave={() => setResourcesOpen(false)}
            >
              <button className={`pr-dropdown-btn ${resourcesOpen ? 'open' : ''}`} onClick={() => setResourcesOpen(o => !o)}>
                Resources <span className={`pr-dropdown-arrow ${resourcesOpen ? 'open' : ''}`}>▾</span>
              </button>
              {resourcesOpen && (
                <div className="pr-dropdown-menu">
                  {PR_RESOURCES.map(r => (
                    <Link key={r.to} to={r.to} className="pr-dropdown-item" onClick={() => setResourcesOpen(false)}>
                      <div className="pr-dropdown-icon" style={{ background: r.bg }}>{r.icon}</div>
                      <div>
                        <div className="pr-dropdown-label">{r.label}</div>
                        <div className="pr-dropdown-desc">{r.desc}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
            <Link to="/login" className="pr-nav-a pr-nav-signin">Sign In</Link>
            <Link to="/register" style={{ background: '#2563eb', color: '#fff', textDecoration: 'none', padding: '9px 18px', borderRadius: 8, fontSize: 14, fontWeight: 600, boxShadow: '0 2px 8px rgba(37,99,235,.3)' }}>Start Free Trial</Link>
            <button className="pr-hamburger" onClick={() => setMenuOpen(true)}><span /><span /><span /></button>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="pr-section" style={{ padding: '80px 24px 56px', background: 'linear-gradient(180deg,#f8faff 0%,#fff 100%)', textAlign: 'center' }}>
        <div style={{ display: 'inline-block', background: '#eff6ff', color: '#2563eb', fontSize: 12, fontWeight: 700, letterSpacing: '1.2px', textTransform: 'uppercase', padding: '5px 14px', borderRadius: 40, border: '1px solid #bfdbfe', marginBottom: 20 }}>Pricing</div>
        <h1 className="pr-hero-h1" style={{ fontSize: 52, fontWeight: 900, letterSpacing: '-2.5px', marginBottom: 16, lineHeight: 1.1 }}>
          Simple, <span className="pr-gradient">honest</span> pricing
        </h1>
        <p style={{ fontSize: 18, color: '#475569', maxWidth: 460, margin: '0 auto 36px', lineHeight: 1.7 }}>
          No hidden fees, no long-term contracts. Start protecting your ads today.
        </p>
      </section>

      {/* Plan Cards */}
      <section className="pr-section" style={{ padding: '0 24px 80px', background: '#fff' }}>
        <div className="pr-plans" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 20, maxWidth: 1020, margin: '0 auto' }}>
          {PLANS.map((p, i) => (
            <div key={i} className="pr-card" style={{
              padding: '36px 28px', borderRadius: 20, position: 'relative',
              background: p.highlighted ? '#2563eb' : '#fff',
              border: p.highlighted ? '2px solid #2563eb' : '1.5px solid #e2e8f0',
              boxShadow: p.highlighted ? '0 24px 64px rgba(37,99,235,.25)' : '0 2px 8px rgba(0,0,0,.04)',
            }}>
              {p.badge && (
                <div style={{ position: 'absolute', top: -13, left: '50%', transform: 'translateX(-50%)', background: '#f59e0b', color: '#fff', fontSize: 11, fontWeight: 700, padding: '4px 18px', borderRadius: 20, whiteSpace: 'nowrap', boxShadow: '0 2px 8px rgba(245,158,11,.4)' }}>{p.badge}</div>
              )}
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '1.2px', textTransform: 'uppercase', color: p.highlighted ? 'rgba(255,255,255,0.7)' : p.color, marginBottom: 10 }}>{p.name}</div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 6 }}>
                <span style={{ fontSize: 50, fontWeight: 900, letterSpacing: '-2px', color: p.highlighted ? '#fff' : '#0f172a' }}>
                  ${p.monthlyPrice}
                </span>
                <span style={{ fontSize: 13, color: p.highlighted ? 'rgba(255,255,255,0.55)' : '#94a3b8' }}>/month</span>
              </div>
              <p style={{ fontSize: 13, color: p.highlighted ? 'rgba(255,255,255,0.65)' : '#64748b', marginBottom: 24, lineHeight: 1.5 }}>{p.desc}</p>
              <Link to="/register" style={{
                display: 'block', textAlign: 'center', padding: '12px 0', borderRadius: 10,
                fontSize: 14, fontWeight: 700, textDecoration: 'none', marginBottom: 28,
                background: p.highlighted ? '#fff' : '#2563eb',
                color: p.highlighted ? '#2563eb' : '#fff',
                boxShadow: p.highlighted ? '0 2px 8px rgba(0,0,0,.15)' : '0 2px 8px rgba(37,99,235,.3)',
                transition: 'all .2s',
              }}>Start Free Trial</Link>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {p.features.map((f, j) => (
                  <div key={j} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13 }}>
                    <span style={{ color: p.highlighted ? 'rgba(255,255,255,0.7)' : '#22c55e', fontWeight: 700, flexShrink: 0, marginTop: 1 }}>✓</span>
                    <span style={{ color: p.highlighted ? 'rgba(255,255,255,0.9)' : '#334155' }}>{f}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 13, color: '#94a3b8' }}>
          All plans include a 7-day free trial · No credit card required · Cancel anytime
        </p>
      </section>

      {/* Comparison Table */}
      <section className="pr-section pr-compare" style={{ padding: '20px 24px 100px', background: '#f8fafc' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{ fontSize: 30, fontWeight: 800, textAlign: 'center', letterSpacing: '-1px', marginBottom: 40 }}>Full feature comparison</h2>
          <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 18, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,.04)' }}>
            {/* Header */}
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
              <div style={{ padding: '16px 24px', fontSize: 12, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px' }}>Feature</div>
              {['Starter', 'Pro', 'Advanced'].map((h, i) => (
                <div key={i} style={{ padding: '16px', fontSize: 14, fontWeight: 700, color: i === 1 ? '#2563eb' : '#475569', textAlign: 'center' }}>{h}</div>
              ))}
            </div>
            {COMPARE.map((row, i) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', borderBottom: i < COMPARE.length - 1 ? '1px solid #f1f5f9' : 'none', background: i % 2 === 0 ? '#fff' : '#fafbfc' }}>
                <div style={{ padding: '13px 24px', fontSize: 13, color: '#475569' }}>{row.label}</div>
                {[row.starter, row.pro, row.advanced].map((v, j) => (
                  <div key={j} style={{ padding: '13px 16px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Cell v={v} />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="pr-section" style={{ padding: '80px 24px 100px', background: '#fff' }}>
        <div className="pr-faq-max" style={{ maxWidth: 720, margin: '0 auto' }}>
          <h2 style={{ fontSize: 32, fontWeight: 800, textAlign: 'center', letterSpacing: '-1px', marginBottom: 48 }}>Frequently asked questions</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {FAQS.map((faq, i) => (
              <div key={i} style={{ border: '1px solid #e2e8f0', borderRadius: 12, overflow: 'hidden', background: openFaq === i ? '#f8fafc' : '#fff' }}>
                <button className="pr-faq-btn" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  <span>{faq.q}</span>
                  <span style={{ color: '#94a3b8', fontSize: 20, transform: openFaq === i ? 'rotate(45deg)' : 'none', transition: 'transform .2s', flexShrink: 0, marginLeft: 12 }}>+</span>
                </button>
                {openFaq === i && (
                  <div style={{ padding: '0 20px 20px', fontSize: 14, color: '#475569', lineHeight: 1.7 }}>{faq.a}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section style={{ padding: '20px 24px 80px', background: '#f8fafc', textAlign: 'center' }}>
        <div style={{ maxWidth: 560, margin: '0 auto', background: 'linear-gradient(135deg,#2563eb,#7c3aed)', borderRadius: 24, padding: '56px 40px' }}>
          <h2 style={{ fontSize: 30, fontWeight: 800, color: '#fff', letterSpacing: '-1px', marginBottom: 14 }}>Start saving your ad spend today</h2>
          <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.75)', marginBottom: 28 }}>7-day free trial. No credit card. 5-minute setup.</p>
          <Link to="/register" style={{ display: 'inline-block', background: '#fff', color: '#2563eb', textDecoration: 'none', padding: '14px 36px', borderRadius: 12, fontSize: 16, fontWeight: 700, boxShadow: '0 4px 16px rgba(0,0,0,.2)' }}>
            Start Free Trial →
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ background: '#0f172a', padding: '40px 24px 24px', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 24, marginBottom: 16, flexWrap: 'wrap' }}>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/#features">Features</FooterLink>
          <FooterLink to="/pricing">Pricing</FooterLink>
          <FooterLink to="/privacy-policy">Privacy</FooterLink>
          <FooterLink to="/terms-policy">Terms</FooterLink>
          <FooterLink to="/cookie-policy">Cookies</FooterLink>
          <FooterLink to="/gdpr">GDPR</FooterLink>
        </div>
        <p style={{ fontSize: 12, color: '#334155' }}>© {new Date().getFullYear()} ClickSaver. All rights reserved.</p>
      </footer>
    </div>
  );
}
